import createSocketClient from './websocket.js';

/**
 * Export the install method for Vue to register the plugin
 * @param {object} Vue Vue instance
 * @param {object} options Plugin options
 * @param {object} options.store Vuex instance
 */
export const install = (Vue, { store }) => {
	// Create WebSocket client
	const ws = createSocketClient();
	// Start connection check
	const setConnectedStatus = () => store.commit('SET_ONLINE', true);
	const setDisconnectedStatus = () => store.commit('SET_ONLINE', false);
	const checkConnection = () => {
		const connectionTimeout = setTimeout(() => setDisconnectedStatus(), 5_000);
		ws.send('GET /status').then(() => {
			clearTimeout(connectionTimeout);
			setConnectedStatus();
		}).catch(() => {
			setDisconnectedStatus();
		});
		setTimeout(() => checkConnection(), 10_000);
	};
	checkConnection();
	// Attach WebSocket client to the application
	Vue.prototype.websocket = ws;
};

export default {
	install
};
